"use client";

import { c as _c } from "react/compiler-runtime";
import { RiCalendarLine, RiGitBranchLine, RiHeart2Line, RiMedicineBottleLine } from "react-icons/ri";
import Badge from "@/components/ui/badge";
import { Skeleton } from "@/components/ui/skeleton";
import { cx } from "@/lib/tailwind-utils";
import { useCarePlanContext } from "./care-plan";
import { CarePlanStep, StepType } from "./types";
interface StepSummaryTagsProps {
  step: CarePlanStep;
  className?: string;
}
export function StepSummaryTags(t0) {
  const $ = _c(28);
  const {
    step,
    className
  } = t0;
  const {
    lookups: t1
  } = useCarePlanContext();
  const {
    serviceById,
    isLookupsLoading
  } = t1;
  let t2;
  if ($[0] !== serviceById || $[1] !== step.serviceIds) {
    let t3;
    if ($[3] !== serviceById) {
      t3 = id => serviceById.get(id);
      $[3] = serviceById;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    t2 = step.serviceIds.map(t3).filter(Boolean);
    $[0] = serviceById;
    $[1] = step.serviceIds;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const selectedServices = t2;
  const hasRawContent = step.serviceIds.length > 0 || step.medicationIds.length > 0 || step.measurements.length > 0 || step.type === StepType.DECISION && (step.branches?.length ?? 0) > 0;
  if (!hasRawContent) {
    return null;
  }
  if (isLookupsLoading && step.serviceIds.length > 0) {
    let t3;
    if ($[5] !== className) {
      t3 = cx("flex flex-wrap gap-1.5", className);
      $[5] = className;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <Skeleton className="h-5 w-20 rounded-full" />;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    let t5;
    if ($[8] !== t3) {
      t5 = <div className={t3}>{t4}</div>;
      $[8] = t3;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    return t5;
  }
  let t3;
  if ($[10] !== className) {
    t3 = cx("flex flex-wrap gap-1.5", className);
    $[10] = className;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== selectedServices[0] || $[13] !== selectedServices.length) {
    t4 = selectedServices.length > 0 && <Badge variant="default" icon={RiCalendarLine} data-care-plan-summary-badge={true} data-care-plan-summary-count={selectedServices.length > 1 || undefined}><span data-care-plan-summary-label={true}>{selectedServices.length === 1 ? selectedServices[0].name : `${selectedServices.length} services`}</span></Badge>;
    $[12] = selectedServices[0];
    $[13] = selectedServices.length;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== step.medicationIds.length) {
    t5 = step.medicationIds.length > 0 && <Badge variant="warning" icon={RiMedicineBottleLine} data-care-plan-summary-badge={true} data-care-plan-summary-count={true}><span data-care-plan-summary-label={true}>{step.medicationIds.length} med<span>{step.medicationIds.length !== 1 && "s"}</span></span></Badge>;
    $[15] = step.medicationIds.length;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== step.measurements.length) {
    t6 = step.measurements.length > 0 && <Badge variant="success" icon={RiHeart2Line} data-care-plan-summary-badge={true} data-care-plan-summary-count={true}><span data-care-plan-summary-label={true}>{step.measurements.length} measure<span>{step.measurements.length !== 1 && "s"}</span></span></Badge>;
    $[17] = step.measurements.length;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== step.branches || $[20] !== step.type) {
    t7 = step.type === StepType.DECISION && (step.branches?.length ?? 0) > 0 && <Badge variant="default" icon={RiGitBranchLine} data-care-plan-summary-badge={true} data-care-plan-summary-count={true}><span data-care-plan-summary-label={true}>{step.branches.length} branch<span>{step.branches.length !== 1 && "es"}</span></span></Badge>;
    $[19] = step.branches;
    $[20] = step.type;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== t3 || $[23] !== t4 || $[24] !== t5 || $[25] !== t6 || $[26] !== t7) {
    t8 = <div className={t3}>{t4}{t5}{t6}{t7}</div>;
    $[22] = t3;
    $[23] = t4;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  return t8;
}